// src/components/MediaPlayer/MediaPlayer.jsx
import React, { useState, useEffect, useRef } from "react";
import PreorderModal from "../PreorderModal/PreorderModal";
import ComingSoonModal from "../ComingSoonModal/ComingSoonModal";
import "./MediaPlayer.css";

function MediaPlayer({ albums }) {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [comingSoonContent, setComingSoonContent] = useState(null);
  const [selectedAlbumIndex, setSelectedAlbumIndex] = useState(0);
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(0.8);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);




  const audioRef = useRef(null);

  const currentAlbum = albums[selectedAlbumIndex];
  const currentTrack = currentAlbum?.songs[currentTrackIndex];

const hasSongPrices = currentAlbum?.songs?.some(s => s.price != null) || false;









  useEffect(() => {
    if (!audioRef.current || !currentTrack) return;
    audioRef.current.src = currentTrack.file;
    audioRef.current.volume = volume;
    setProgress(0);
    setCurrentTime(0);
    setDuration(0);
    if (isPlaying) {
      audioRef.current.play().catch(err => {
        if (err.name !== 'AbortError') console.error('Playback error:', err);
      });
    }
  }, [currentTrack]);

  useEffect(() => {
    if (audioRef.current) audioRef.current.volume = volume;
  }, [volume]);

  const handleAlbumChange = (e) => {
    const idx = Number(e.target.value);
    setSelectedAlbumIndex(idx);
    setCurrentTrackIndex(0);
    setProgress(0);
    setCurrentTime(0);
    setIsPlaying(false);
    if (audioRef.current) audioRef.current.pause();
  };

  const handleTrackChange = (idx) => {
    setCurrentTrackIndex(idx);
    setProgress(0);
    setCurrentTime(0);
    setIsPlaying(true);
  };

  const handlePrevTrack = () => {
    if (!currentAlbum) return;
    const nextIndex = currentTrackIndex === 0 ? currentAlbum.songs.length - 1 : currentTrackIndex - 1;
    setCurrentTrackIndex(nextIndex);
    setIsPlaying(true);
  };

  const handleNextTrack = () => {
    if (!currentAlbum) return;
    const nextIndex = currentTrackIndex === currentAlbum.songs.length - 1 ? 0 : currentTrackIndex + 1;
    setCurrentTrackIndex(nextIndex);
    setIsPlaying(true);
  };

  const togglePlayPause = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play().catch(err => {
        if (err.name !== 'AbortError') console.error('Playback error:', err);
      });
      setIsPlaying(true);
    }
  };

  const handleTimeUpdate = () => {
    if (!audioRef.current) return;
    const dur = audioRef.current.duration;
    const cur = audioRef.current.currentTime;
    setCurrentTime(cur);
    if (dur > 0) setProgress((cur / dur) * 100);
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) setDuration(audioRef.current.duration);
  };

  const handleEnded = () => {
    const nextIndex = currentTrackIndex === currentAlbum.songs.length - 1 ? 0 : currentTrackIndex + 1;
    setCurrentTrackIndex(nextIndex);
    setIsPlaying(true);
  };

  const handleProgressClick = (e) => {
    if (!audioRef.current || !duration) return;
    const bar = e.currentTarget;
    const rect = bar.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    audioRef.current.currentTime = ratio * duration;
  };

  const formatTime = (secs) => {
    if (!secs || isNaN(secs)) return "0:00";
    const m = Math.floor(secs / 60);
    const s = Math.floor(secs % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handlePreorder = async (item) => {
    try {
      const res = await fetch('/api/products');
      const products = await res.json();
      const match = products.find(p => p.id === item.id);
      setModalContent({
        ...item,
        image: item.image || item.cover,
        preorders: match?.preorders || 0,
        preorderGoal: match?.preorderGoal || null
      });
    } catch (err) {
      console.error('Failed to fetch product data:', err);
      setModalContent({ ...item, image: item.image || item.cover });
    }
    setShowModal(true);
  };

  const handleBuy = (item) => {
    setComingSoonContent({ ...item, image: item.image || item.cover });
    setShowComingSoon(true);
  };

  if (!currentAlbum) return <p>No album selected.</p>;

  return (
    <>
      {showModal && modalContent && (
        <PreorderModal product={modalContent} onClose={() => setShowModal(false)} />
      )}
      {showComingSoon && comingSoonContent && (
        <ComingSoonModal
          product={comingSoonContent}
          onClose={() => {
            setShowComingSoon(false);
            setComingSoonContent(null);
          }}
        />
      )}

      <audio
        ref={audioRef}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={handleEnded}
        preload="metadata"
      />


<div className="announcement-banner">
  <div className="announcement-banner-inner">
    <span className="announcement-badge">New</span>
    <div className="announcement-text">
      <span className="announcement-title">Random Hitz is here. Get the Album or individual tracks are available because of all the different genres.</span>
      <span className="announcement-message">
      

      </span>
    </div>
  </div>
</div>




      <div className="media-player-visual">
        <div className="media-player-left">
          <div className="media-player-cover-wrap">
            <img
              className="media-player-cover"
              src={currentAlbum.cover.startsWith("/") ? currentAlbum.cover : `/${currentAlbum.cover}`}
              alt={currentAlbum.name}
            />
          </div>

          <div className="media-player-meta">
            <span className="media-player-label">Album</span>
            <h3 className="media-player-title">{currentAlbum.name}</h3>
            <span className="media-player-nowplaying">
              {currentTrack ? currentTrack.title : ""}
            </span>

            <div className="media-player-album-select">
              <label htmlFor="albumSelect">Albums</label>
              <select id="albumSelect" value={selectedAlbumIndex} onChange={handleAlbumChange}>
                {albums.map((album, idx) => (
                  <option key={album.name} value={idx}>
                    {album.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="media-player-action-btns">
              {currentAlbum.preorder && (
                <button
                  className="media-player-preorder-btn"
                  onClick={() => handlePreorder(currentAlbum)}
                >
                  Preorder
                </button>
              )}
               
    {/* Hide single Buy for now */}
    {/* <button
      className="media-player-track-btn media-player-track-buy"
      onClick={() => handleBuy(songProduct)}
    >
      Buy
    </button> */}
            </div>
          </div>
        </div>


<div className="media-player-right">
  <div className="media-player-tracklist">
    {currentAlbum.songs.map((song, idx) => {
const canBuySong = Number.isFinite(song.price);
   const songProduct = {
  id: song.id || `${currentAlbum.id}-song-${idx}`,
  name: song.name || song.title,
  price: song.price ?? null, // Do NOT fall back to currentAlbum.price
  cover: currentAlbum.cover,
  image: currentAlbum.cover,
  preorder: currentAlbum.preorder,
  type: 'song',
  albumId: currentAlbum.id,
  albumName: currentAlbum.name,
  forSale: canBuySong
};

      return (
        <div key={songProduct.id} className="media-player-track-row">
          <button
            type="button"
            className={`media-player-track ${idx === currentTrackIndex ? "is-active" : ""}`}
            onClick={() => handleTrackChange(idx)}
          >
            <span className="track-index">
              {idx === currentTrackIndex ? "▶" : idx + 1}
            </span>
            <span className="track-title">{song.title}</span>
          </button>

        {hasSongPrices && canBuySong && (
  <div className="media-player-track-actions">
    {currentAlbum.preorder && (
      <button
        className="media-player-track-btn media-player-track-preorder"
        onClick={() => handlePreorder(songProduct)}
                >
                  PreOrder
                </button>
              )}
             
    {/* Hide single Buy for now */}
    {/* <button
      className="media-player-track-btn media-player-track-buy"
      onClick={() => handleBuy(songProduct)}
    >
      Buy
    </button> */}
            </div>
          )}
        </div>
      );
    })}
  </div>

  <div
    className="media-player-waveform"
    onClick={handleProgressClick}
    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '1rem 0' }}
  >
    <div className="progress-bar" style={{ width: '100%', position: 'relative', height: '6px', background: '#333', borderRadius: '3px' }}>
      <div
        className="progress-fill"
        style={{
          width: `${progress}%`,
          height: '100%',
          borderRadius: '3px',
          background: 'linear-gradient(90deg, #ff0000, #ffaa00, #ffff00, #00ff00)',
          transition: 'width 0.1s linear'
        }}
      />
    </div>
  </div>

  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '0.75rem',
      color: '#aaa',
      marginTop: '-0.5rem',
      marginBottom: '0.5rem'
    }}
  >
    <span>{formatTime(currentTime)}</span>
    <span>{formatTime(duration)}</span>
  </div>

  <div className="media-player-controls">
    <div className="controls-main">
      <button type="button" className="controls-btn" onClick={handlePrevTrack}>«</button>
      <button
        type="button"
        className={`controls-btn controls-play ${isPlaying ? "is-playing" : ""}`}
        onClick={togglePlayPause}
      >
        {isPlaying ? "⏸" : "▶"}
      </button>
      <button type="button" className="controls-btn" onClick={handleNextTrack}>»</button>
    </div>

    <div className="controls-volume">
      <span className="volume-icon">🔊</span>
      <input
        className="volume-slider"
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={volume}
        onChange={(e) => setVolume(parseFloat(e.target.value))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MediaPlayer;